import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import LiveHelpIcon from '@mui/icons-material/LiveHelp';
import PropTypes from 'prop-types';
import React, {memo} from 'react';

import {
  ListItemIcon,
  NavMenuButton,
  NavMenuLink,
} from '@apps-common/ui-components/NavBar';

const HelpMenu = ({children}) => {
  return (
    <NavMenuButton
      title="Resources and Help"
      label={<HelpOutlineIcon fontSize="small" />}
      data-qe="help-menu"
    >
      <NavMenuLink
        href="https://developers.planet.com/docs/apps/basemapsviewer/"
        data-qe="user-guide-link"
      >
        <ListItemIcon>
          <LiveHelpIcon />
        </ListItemIcon>
        User Guide
      </NavMenuLink>
      {children}
    </NavMenuButton>
  );
};

HelpMenu.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
};

export default memo(HelpMenu);
